import React from 'react'
import {Container} from 'react-bootstrap';
export const Footer = () => {
  return (
    <footer>
      <Container>
      <p>
        <span>Notes 2.0 </span>&nbsp;|<i className="fas fa-copyright"></i>&nbsp;2023 | All Rights
        Reserved 
      </p>
      </Container>
    </footer>
  )
}
